import { connect } from 'react-redux';
import SubBar from '../../components/nav/SubBar';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    meta: state.meta,
  }
}

const SubNavBar = connect(
  mapStateToProps,
  null,
)(SubBar)

export default SubNavBar;
